import { AuthMode } from "@cayo/shared/api/types/sso";
import logger from "@cayo/shared/libs/logger";
import { appSettings } from "@cayo/shared/settings/appSettings";

export type AuthContext = {
  authMode?: AuthMode;
  loginHint?: string;
};

export class AuthContextStore {
  private readonly log = logger.getLogger("AuthContextStore");

  public get(): AuthContext {
    const userSettings = appSettings.userSetting.get();

    return {
      authMode: userSettings?.authMode,
      loginHint: userSettings?.loginHint,
    };
  }

  public setSsoLoginContext(authMode: AuthMode) {
    this.log.debug("setSsoLoginContext", authMode);

    appSettings.userSetting.update({
      authMode,
    });
  }

  public setLoginHint(loginHint?: string) {
    this.log.debug("setLoginHint", loginHint);

    appSettings.userSetting.update({ loginHint });
  }

  public clear() {
    this.log.debug("clear");

    appSettings.userSetting.update({
      authMode: undefined,
      loginHint: undefined,
    });
  }
}

const authContextStore = new AuthContextStore();

export { authContextStore };
